import { render, staticRenderFns } from "./Offertory.vue?vue&type=template&id=3c97f127&scoped=true"
import script from "./Offertory.vue?vue&type=script&lang=js"
export * from "./Offertory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97f127",
  null
  
)

export default component.exports